import styled from 'styled-components'

export const Wrapper = styled.div`
  .ant-list-item {
    border: none;
  }
`

export const Header = styled.h2`
  margin: 0;
`

export const Footer = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
`
